const slugRewrites = {
  "radiot/radio-dei-helsinki": "radiot-helsinki",
  "radiot/radio-dei-valtakunnallinen": "radiot-valtakunnallinen",
  "radiot/radio-dei-lohja": "radiot-lohja",
  "radiot/radio-dei-oulu": "radiot-oulu",
  "radiot/radio-dei-rovaniimi": "radiot-rovaniemi",
  "radiot/radio-dei-rovaniemi": "radiot-rovaniemi",
  "radiot/radio-dei-pohjanma": "radiot-pohjanma",
  "radiot/radio-dei-turku": "radiot-turku",
  "radiot/radio-dei-kaajani": "radiot-kaajani"
};

export default slugRewrites;
